import { useNavigate, useParams } from 'react-router-dom';
import { ShopsList } from './ShopsList';

/**
 * Thin wrapper для маршрута `/furniture/:globalId/shops` (Блок 5, E7, ADR-0068 §5).
 *
 * Аналог DecorsShopsRoute, но БЕЗ subKind (фурнитура — единый каталог) и БЕЗ
 * повторного decodeURIComponent: react-router-dom v7 уже декодирует path params
 * (повторный decode ломается на Global_ID с `%`, URIError). Пробрасывает props
 * в общий Container `<ShopsList entityKind="furniture" />` (ADR-0007).
 */
export function FurnitureShopsRoute() {
  const navigate = useNavigate();
  const params = useParams<{ globalId: string }>();
  const globalId = params.globalId ?? '';
  return (
    <ShopsList
      entityKind="furniture"
      globalId={globalId}
      onBackToCard={() => navigate(`/furniture/${encodeURIComponent(globalId)}`)}
    />
  );
}
